import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Button } from 'components';
import { GrayButton, SecondaryButton } from 'components';
import * as pubsub from '../../helpers/pubsub';
import * as styles from './ModalTopBar.scss';
var ModalTopBar = (_dec = connect(function (state) {
  return {
    organization: state.organization.current
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ModalTopBar, _Component);

  var _super = _createSuper(ModalTopBar);

  function ModalTopBar() {
    var _this;

    _classCallCheck(this, ModalTopBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleBackClick", function () {
      if (_this.props.handleGoBack) {
        _this.props.handleGoBack();

        return true;
      }

      if (_this.props.backUrl) {
        return browserHistory.push(_this.props.backUrl);
      }

      _this.context.router.goBack();
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseClick", function () {
      if (_this.props.handleClose) {
        _this.props.handleClose();

        return true;
      }

      if (_this.props.closeUrl) {
        browserHistory.push(_this.props.closeUrl);
      }

      if (_this.props.backUrl) {
        return browserHistory.push(_this.props.backUrl);
      }

      _this.context.router.goBack();
    });

    return _this;
  }

  _createClass(ModalTopBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          organization = _this$props.organization,
          postBtnText = _this$props.postBtnText;
      return /*#__PURE__*/React.createElement("div", {
        id: "ModalTopBar",
        className: styles.topbar,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.handleBackClick,
        className: styles.backLink
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-android-arrow-back ".concat(styles.backArrow)
      }), this.props.backLabel ? this.props.backLabel : 'Back'), this.props.innerStuff, this.props.showCloseBtn && /*#__PURE__*/React.createElement("div", {
        className: styles.rightWrap
      }, /*#__PURE__*/React.createElement("i", {
        onClick: this.handleCloseClick,
        className: "icon ion-ios-close-empty ".concat(styles.closeButton)
      })));
    }
  }]);

  return ModalTopBar;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired,
  children: PropTypes.array,
  postBtnText: PropTypes.any,
  adScreen: PropTypes.bool,
  adStep: PropTypes.number,
  style: PropTypes.object,
  closeUrl: PropTypes.string,
  backUrl: PropTypes.string
}), _defineProperty(_class2, "defaultProps", {
  postBtnText: 'Post Now',
  adScreen: false,
  showCloseBtn: true,
  style: {}
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _temp)) || _class);
export default ModalTopBar;